import { CustomComponentProps } from "utils/types/general.types";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export type DropdownProps = CustomComponentProps & {
    items: string[];
    selected: string;
    handleSelect: React.Dispatch<React.SetStateAction<string>>;
    align?: "left" | "right" | "center";
    title?: string;
};

const Dropdown = ({
    items,
    selected,
    handleSelect,
    align = "right",
    title,
    className,
    style
}: DropdownProps) => {
    return (
        <div
            className={`my-drop-down relative w-fit ${className}`}
            style={style}
        >
            {/* <div> */}
            <MoreVertIcon
                fontSize="medium"
                className="my-drop-down-more-vertical dark:text-white"
            />
            {/* </div> */}
            <div
                className={`my-drop-down-div ${align} bg-neutral-100 dark:bg-momeento-300 rounded`}
            >
                {title && (
                    <h3 className="font-medium dark:text-white">{title}</h3>
                )}
                <ul>
                    {items.map((i) => (
                        <li
                            key={i}
                            className={`my-drop-down-item dark:text-white ${i == selected && "selected"} rounded`}
                            onClick={() => handleSelect(i)}
                        >
                            {i}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Dropdown;
